import { useState, useEffect } from "react";
import ApiCategory from "models/data/api/ApiCategory";
import { request } from "graphql-request";
import { baseUrl } from "services/shared/Environment";
import { categoriesQuery, categoryStoriesQuery } from "./HomepageStories.utils";
import { parseApiCategory } from "data/api/ApiCategory";
import { ApiStory, parseApiStory } from "data/api/ApiStory";

export function useCategories() {
  const [categories, setCategories] = useState<ApiCategory[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await request(
          `${baseUrl()}/api/graphql`,
          categoriesQuery()
        );
        setCategories(
          response?.categories?.map((category) => parseApiCategory(category))
        );
        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    };
    fetchData();
  }, []);

  return { categories, loading };
}

export function useCategoryStories({
  categoryId,
  numStoriesLoaded
}: {
  categoryId: string;
  numStoriesLoaded: number;
}) {
  const [stories, setStories] = useState<ApiStory[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await request(
          `${baseUrl()}/api/graphql`,
          categoryStoriesQuery({ categoryId, numStoriesLoaded })
        );
        setStories(
          response?.categoryStories?.map((story) => parseApiStory(story))
        );
        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    };
    fetchData();
  }, []);

  return { stories, loading };
}
